export default __webpack_public_path__ + "static/step22-ab26c58c6d014befdfd4000a063c5923.png";